import React,{useState,useEffect} from "react";
import { LineChart, BarChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import axios from 'axios'
import CustomTooltip from './CustomTooltip'

function StatisticsGraph({user , period , month , passSelectedDay , setShowPrevGraph , graphState , showYearlyGraph , resetYearlyGraph}) {

    const api_base_url = process.env.REACT_APP_API_BASE_URL;

    // const data = [
    //     { name: "Page A", uv: 5, pv: 2400, amt: 2400 },
    //     { name: "Page B", uv: 1, pv: 1398, amt: 2210 },
    //     { name: "Page C", uv: 2, pv: 9800, amt: 2290 },
    //     { name: "Page D", uv: 4, pv: 3908, amt: 2000 },
    //     { name: "Page E", uv: 5, pv: 4800, amt: 2181 }
    //   ];

    

    // Mock data for different time periods
const yearlyData = [
    { month: 1, name: "Jan", orders: 0, list: []},
    { month: 2, name: "Feb", orders: 0, list: [] },
    { month: 3, name: "Mar", orders: 0, list: [] },
    { month: 4, name: "Apr", orders: 0, list: [] },
    { month: 5, name: "May", orders: 0, list: [] },
    { month: 6, name: "Jun", orders: 0, list: [] },
    { month: 7, name: "Jul", orders: 0, list: [] },
    { month: 8, name: "Aug", orders: 0, list: [] },
    { month: 9, name: "Sep", orders: 0, list: [] },
    { month: 10, name: "Oct", orders: 0, list: [] },
    { month: 11, name: "Nov", orders: 0, list: [] },
    { month: 12, name: "Dec", orders: 0, list: [] }
    ];

// Create an array for monthlyData with 31 days
const monthlyData = Array.from({ length: 31 }, (_, index) => ({
    day: index + 1,  // day will range from 1 to 31
    orders: 0,       // initialize orders to 0
    success: 0,      // initialize successful orders to 0
    unpaid: 0,       // initialize unpaid orders to 0
    ordersList: []   // list to store orders for the day
}));

// Function to format the hour into 12-hour format with AM/PM
const formatHour = (hour) => {
    const ampm = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12; // Convert 0 or 12 to 12
    return `${formattedHour} ${ampm}`;
  };
  
// const hourlyData = Array.from({ length: 24 }, () => ({
//     orders: 0,
//     success: 0,
//     unpaid: 0,
//     ordersList: [],
// }));

const [data, setData] = useState([]);

// //(data);

const [filteredDataInYears, setFilteredDataInYears] = useState(data);

const [filteredDataWithinYrs, setFilteredDataWithinYrs] = useState(data);

// //(filteredDataWithinYrs);

//   ..........................................yearlyData.....................................................

const updateYearlyData = (ordersData) => {
    // Create a map to count orders and paid/unpaid orders per month
    const ordersPerMonth = {};
  
    // Loop through ordersData and count the orders and paid/unpaid status for each month
    ordersData.forEach(order => {
      
      const orderMonth = new Date(order.orderDate).getMonth() + 1; // getMonth() is zero-based
  
      // Initialize month object if it doesn't exist
      if (!ordersPerMonth[orderMonth]) {
        ordersPerMonth[orderMonth] = {
          totalOrders: 0,
          paid: 0,
          unpaid: 0,
          ordersList: [] // Initialize orders list for the month
        };
      }
  
      // Increment the total order count for the month
      ordersPerMonth[orderMonth].totalOrders++;
  
      // Check paid/unpaid status and increment accordingly
      if (order.paid_unpaid === 1) {
        ordersPerMonth[orderMonth].paid++;
      } else {
        ordersPerMonth[orderMonth].unpaid++;
      }
  
      // Add the order to the ordersList for the respective month
      ordersPerMonth[orderMonth].ordersList.push(order);
    });
  
    // Update the yearlyData with the counted orders and paid/unpaid status
    const updatedYearlyData = yearlyData.map((monthData) => {
      const monthStats = ordersPerMonth[monthData.month] || { totalOrders: 0, paid: 0, unpaid: 0, ordersList: [] };
  
      return {
        ...monthData,
        orders: monthStats.totalOrders,
        success: monthStats.paid,
        unpaid: monthStats.unpaid,
        list: monthStats.ordersList // Add ordersList to each month
      };
    });
  
    // Set the updated yearly data to state (if applicable)
    setFilteredDataWithinYrs(updatedYearlyData);
  };
    

//   ..........................................monthlyData.....................................................

const [filteredDataInMonths,setFilteredDataInMonths] = useState([])

// //(filteredDataInMonths);

const [filteredDataWithinMonths,setFilteredDataWithinMonths] = useState([])

const updateMonthlyData = (ordersData) => {
    // Loop through ordersData and count the orders and paid/unpaid status for each day
    ordersData.forEach(order => {
        const orderDate = new Date(order.orderDate);
        const orderDay = orderDate.getDate(); // Get the day of the month

        // Ensure the order day is within the range of 1-31
        if (orderDay >= 1 && orderDay <= 31) {
            // Increment the order count for the day
            monthlyData[orderDay - 1].orders++;

            // Add the order to the orders list for the day
            monthlyData[orderDay - 1].ordersList.push(order);
            
            // Check paid/unpaid status and increment accordingly
            if (order.paid_unpaid === 1) {
                monthlyData[orderDay - 1].success++;
            } else {
                monthlyData[orderDay - 1].unpaid++;
            }
        }
    });

    // Update the state with the calculated monthly data (if applicable)
    setFilteredDataWithinMonths(monthlyData);
};

// ....................................dailyData............................

const [filteredDataInHours,setFilteredDataInHours] = useState([])

// //(filteredDataInHours);

const updateHourlyData = (ordersData) => {
    // Create an array to hold data for each hour
    const hourlyData = Array.from({ length: 24 }, (_, hour) => ({
        orders: 0,
        success: 0,
        unpaid: 0,
        ordersList: [],
        time: hour == 0 ? '12 AM' : (hour < 12 ? `${hour} AM` : hour == 12 ? '12 PM' : `${hour - 12} PM`) // Set orderTime for each hour
    }));

    ordersData.forEach(order => {
        // Extract the hour from orderTime
        const orderTimeParts = order.orderTime.split(' '); // Split into time and AM/PM
        const timeParts = orderTimeParts[0].split(':'); // Split into hours and minutes
        let orderHour = parseInt(timeParts[0]); // Get the hour part

        // Convert to 24-hour format if it's PM
        if (orderTimeParts[1] === 'PM' && orderHour !== 12) {
            orderHour += 12;
        } else if (orderTimeParts[1] === 'AM' && orderHour === 12) {
            orderHour = 0; // Handle midnight case
        }

        // Ensure the order hour is within the range of 0-23
        if (orderHour >= 0 && orderHour < 24) {
            // Increment the order count for the hour
            hourlyData[orderHour].orders++;

            // Add the order details (including orderTime) to the orders list for the hour
            hourlyData[orderHour].ordersList.push({
                order_id: order.order_id, // Add order ID or any other identifiers
                orderTime: order.orderTime, // Include the order time
                paid_unpaid: order.paid_unpaid // Include payment status if needed
            });
            
            // Check paid/unpaid status and increment accordingly
            if (order.paid_unpaid === 1) {
                hourlyData[orderHour].success++;
            } else {
                hourlyData[orderHour].unpaid++;
            }
        }
    });

    //(hourlyData);
    // Update the state with the calculated hourly data
    setFilteredDataInHours(hourlyData);
};

  const [view, setView] = useState('month'); // 'month', 'week', 'day', 'hour'
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);

  useEffect(() => {
    if (filteredDataInYears) {
        updateYearlyData(filteredDataInYears);
    }
    if (selectedMonth) {
        const selectedMonthData = yearlyData.find(monthData => monthData.name === selectedMonth);
        const month = selectedMonthData.month

        const filteredResults = filteredDataWithinYrs.filter(data => data.month === month);
        const list = filteredResults[0].list
        setFilteredDataInMonths(list)
        updateMonthlyData(list);
    }
    if (selectedDay) {

        const filteredResults = filteredDataInMonths.filter(data => {
            const orderDate = new Date(data.orderDate); // Convert the orderDate to a Date object
            return orderDate.getUTCDate() === selectedDay; // Compare the day of the month
        });
        updateHourlyData(filteredResults);
    }
  }, [filteredDataInYears,selectedMonth,selectedDay]);

//   //(selectedMonth);

  const handleBarClick = (data) => {
    if (view === 'month') {
        month(data.name)
        setSelectedMonth(data.name);
        setView('day');
        //("hi");
    } else if (view === 'day') {
        setSelectedDay(data.day);
        passSelectedDay(data.day)
        setView('hour');
        //("hello");
    }
  };

  useEffect(() =>{
    // if (filteredDataInHours.length > 0 && filteredDataWithinMonths.length > 0) {
    //     setShowPrevGraph('Hours')
    // }
    // if (filteredDataWithinMonths.length > 0 && !filteredDataInHours.length > 0) {
    //     setShowPrevGraph('Days')
    // }
    if (showYearlyGraph) {
        setFilteredDataWithinMonths([])
        setFilteredDataInHours([])
        resetYearlyGraph(false)
        setSelectedDay(null)
        setSelectedMonth(null)
        setView('month')
    }
  },[showYearlyGraph])

  useEffect(() =>{
    if (graphState === 'Months') {
        //("hi");
        setFilteredDataWithinMonths([])
        setView('month')
    } else if (graphState === 'Days') {
        setFilteredDataInHours([])
        setView('day')
        //("hello");
    }
  },[graphState])
  
//   const monthlyData = Array.from({ length: 30 }, (_, i) => ({
//     name: `${i + 1}`,
//     uv: Math.floor(Math.random() * 10) + 1
//   }));

  const weeklyData = [
    { name: "Week 1", orders: 30 },
    { name: "Week 2", orders: 40 },
    { name: "Week 3", orders: 35 },
    { name: "Week 4", orders: 28 }
  ];


//   //(filteredDataInYears);

    // useEffect(() => {
    // if (period.label) {
    //     const year = Number(period.label); // Ensure it's a number
    //     const filtered = data.filter(item => {
    //     const orderYear = new Date(item.orderDate).getFullYear();
    //     return orderYear === year; // Compare orderYear with the selected year
    //     });
    //     // //(filtered);
    //     setFilteredDataInYears(filtered);
    // }
    // }, [period, data]);

    const generateTicks = (data) => {
        // Find the maximum value from the dataset
        const maxValue = Math.max(...data.map(item => item.orders));
      
        // Create an array of ticks from 0 to maxValue
        const ticks = [];
        for (let i = 0; i <= maxValue; i++) {
          ticks.push(i); // Include all integers from 0 to maxValue
        }
        return ticks;
      };
      
      // Assuming your data is filteredDataInHours, filteredDataWithinMonths, or filteredDataWithinYrs
      const ticks = generateTicks(filteredDataInHours.length > 0 ? filteredDataInHours : filteredDataWithinMonths.length > 0 ? filteredDataWithinMonths : filteredDataWithinYrs);

    const handleGetTotalOrders = async (id) => {
        try {
            const response = await axios.get(`${api_base_url}/main/getTotalOrders/${id}`);
            if (response.status === 200) {
                setData(response.data.data)
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    // useEffect(() => {
    //     if (user && user.value) {
    //         handleGetTotalOrders(user.value);
    //     }
    // },[api_base_url,user])

  return (
    <div className="w-full h-[15rem] z-[1111]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={filteredDataInHours.length > 0 ? filteredDataInHours : filteredDataWithinMonths.length > 0 ? filteredDataWithinMonths : filteredDataWithinYrs}
          margin={{ top: 5, right: 25, left: -25, bottom: 5 }}
        >
          <XAxis dataKey={`${filteredDataInHours.length > 0 ? 'time' : filteredDataWithinMonths.length > 0 ? 'day' : 'name'}`} tick={{ fontSize: 14 }}/>
          <YAxis
            yAxisId="left"
            tick={{ fontSize: 15 }}
            ticks={ticks}
            tickFormatter={(value) => Math.floor(value)} 
          />
          {/* <YAxis yAxisId="right" orientation="right" /> */}
          {/* <Tooltip content={<CustomTooltip filteredDataInHours={filteredDataInHours}/>}/> */}
          <CartesianGrid stroke="#f5f5f5" />
          {/* <Bar dataKey="unpaid" fill="#000" yAxisId="left" /> */}
          <Bar dataKey="orders" fill="#c30000" yAxisId="left" onClick={handleBarClick}/>
          {/* <Bar dataKey="success" fill="#387908" yAxisId="left" onClick={handleBarClick} /> */}
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default StatisticsGraph
